module.exports = __webpack_public_path__ + "img/loading1.92a4a31e.gif";